import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import "./MainInvoice.css";
import PdfDocument from "./Invoice";
import Invoice from "../../api/Invoice";

function MainInvoice() {
  const fileName = "Invoice.pdf";

  const params = useParams();
  const [invoiceData, SetInvoiceData] = useState({
    id: "5df3180a09ea16dc4b95f910",
    invoice_no: "201906-28",
    balance: "$2,283.74",
    fullname: "MANTRIX",
    email: "susanafuentes@mantrix.com",
    phone: "+1 (872) 588-3809",
    address: "922 Campus Road, Drytown, Wisconsin, 1986",
    trans_date: "26-11-2021",
    due_date: "26-11-2021",
    companyID: "10001",
    companyName: "xyz company",
    items: [
      {
        sno: 1,
        desc: "FinePix Pro2 3D Camera",
        qty: 2,
        rate: 1600.00,
      },
      // {
      //     sno: 2,
      //     desc: "Luxury Ultra thin Wrist Watch",
      //     qty: 1,
      //     rate: 300.99,
      // },
      // {
      //     sno: 3,
      //     desc: "Duracell Ultra Alkaline Battery AA, 4 pcs",
      //     qty: 1,
      //     rate: 145.99,
      // }
    ]
  });
  useEffect(() => {
    const HandleReq = async () => {
      const data = await Invoice.get('/get-invoice/' + params.id);
      const filldata = {
        id: "5df3180a09ea16dc4b95f910",
        invoice_no: data.data.invNo,
        balance: "$2,283.74",
        fullname: data.data.cName,
        email: data.data.email,
        phone: data.data.mob,
        address: data.data.address,
        trans_date: data.data.date,
        due_date: data.data.date,
        companyID: "10001",
        companyName: "xyz company",
        items: [
          {
            sno: 1,
            desc: data.data.product,
            qty: data.data.quantity,
            rate: data.data.unit,
          },
          // {
          //     sno: 2,
          //     desc: "Luxury Ultra thin Wrist Watch",
          //     qty: 1,
          //     rate: 300.99,
          // },
          // {
          //     sno: 3,
          //     desc: "Duracell Ultra Alkaline Battery AA, 4 pcs",
          //     qty: 1,
          //     rate: 145.99,
          // }
        ]
      };
      SetInvoiceData(filldata);

    }
    HandleReq();
  }, [SetInvoiceData, params]);



  return (
    <div className="MainInvoice">
      <PDFViewer width={800} height={500} showToolbar={false}>
        <PdfDocument invoicedata={invoiceData} />
      </PDFViewer>

      <div className='download-link'>
        <PDFDownloadLink
          document={<PdfDocument invoicedata={invoiceData} />}
          fileName={fileName}
        >
          {({ blob, url, loading, error }) =>
            loading ? "Loading..." : "Download Invoice"
          }
        </PDFDownloadLink>
      </div>
    </div>
  );
}

export default MainInvoice;